export default __webpack_public_path__ + "static/media/14.092de8f2.png";